import React from "react"
import Table from "reactstrap/lib/Table"
import moment from "moment"
import classNames from "classnames";
import { forEachSeries } from "p-iteration"
import {
  Button,
  ButtonGroup,
} from "reactstrap";
import { formatPrice } from "../../../helpers/pricing"
import { formatPaymentType, formatPaymentSubtype } from '../../../helpers/payment';
import { getPaymentsRequest, getPaymentStatsForSOARequest } from "../../../api/payment"

class SOA extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            clientPayments: null,
            soaStats: null,
            page: 0,
            total: 0,
            limit: 25,
            pages: 0,
            current_page: 0,
            start_page: 0,
            end_page: 9,
            first_page: 0,
            last_page: 0,
            search: "",
            tabSelected: "principal",
            filters: {
              type: "downPayment",
              subtype: 'principal'
            },
            loading: true
        }
    }

    async componentDidMount() {
      await this.getPayments();
      await this.getStats();
    }

    getPayments = async () => {
      const { limit, filters } = this.state
      const { client } = this.props

      this.setState ({loading: true})

      let requestFilters = {
        ...filters,
        client: client._id
      }

      let paymentsObj;
      let clientPayments = [];
      let total;

      
      if(requestFilters.subtype === 'principal') {
        let principalFilters = [
          {...requestFilters, type: 'downPayment', subtype: 'reservation'},
          {...requestFilters, type: 'downPayment', subtype: 'principal'},
          {...requestFilters, type: 'downPayment', subtype: 'spot'},
          {...requestFilters, type: 'balancePayment', subtype: ''},
        ]
        await forEachSeries(principalFilters, (async (filters) => {
          paymentsObj = await getPaymentsRequest(filters);
          clientPayments.push(...paymentsObj.payments)
        }))
      } else {
        paymentsObj = await getPaymentsRequest(requestFilters);

        clientPayments = paymentsObj.payments
        total = paymentsObj.total

      }
      
      const pages = Math.ceil(total / limit)
      const last_page = pages - 1
      const end_page = pages > 10 ? 9 : pages - 1

      this.setState({
          clientPayments,
          total,
          pages,
          last_page,
          end_page,
          loading: false
      })
  }
      

    getStats = async () => {
      console.log('getStats')
      const { client } = this.props

      console.log('client', client)
      this.setState ({loading: true})
      
      const statssObj = await getPaymentStatsForSOARequest(client._id);

      this.setState({
          soaStats: statssObj,
          loading: false
      })
    }

    changeActiveTab = (e, tabState, tadName) => {
        e.preventDefault();
        this.setState({
          [tabState]: tadName,
        });
    };

    changeTabSelected = (e, tabState, tabName) => {
      e.preventDefault();

      let type;
      let subtype;

      if (tabName === "principal" ) {
        subtype = tabName
    } else if (tabName === "miscelaneous" || tabName === "rental") {
        type = "downPayment";
        subtype = tabName
    } else if (tabName === "penalty"){
        type = "penaltyPayment";
        subtype = ''
    } else if (tabName === "commission"){
      type = "commissionPayment";
      subtype = ''
  }


      this.setState({
        [tabState]: tabName,
          filters: {type,subtype},
      }, this.getPayments);
    };

    render() {
        const { clientPayments, soaStats, loading, tabSelected } = this.state
        const { client } = this.props;

        const { unit } = client;

        return (
            <div className="content">
                <div className="d-flex flex-column">
                  <div className="mb-3">
                      <div className="custom-values my-3">
                        <div className="value">
                            <span>TCP</span>
                            <p className="text-success">{unit.selectedModel && unit.selectedModel.tcp ? formatPrice(unit.selectedModel.tcp) : "N/A"}</p>
                        </div>
                        <div className="value">
                            <span>Total DP</span>
                            <p className="text-success">{soaStats && (soaStats.totalDp || soaStats.totalDp === 0) ? formatPrice(soaStats.totalDp) : "N/A"}</p>
                        </div>
                        <div className="value">
                            <span>Total DP Balance</span>
                            <p className="text-success">{soaStats && (soaStats.totalBalanceDp || soaStats.totalBalanceDp === 0) ? formatPrice(soaStats.totalBalanceDp) : "N/A"}</p>
                        </div>
                        <div className="value">
                            <span>Total MF</span>
                            <p className="text-success">{soaStats && (soaStats.totalMf || soaStats.totalMf === 0) ? formatPrice(soaStats.totalMf) : "N/A"}</p>
                        </div>
                        <div className="value">
                            <span>Total MF Balance</span>
                            <p className="text-success">{soaStats && (soaStats.totalBalanceMf || soaStats.totalBalanceMf === 0) ? formatPrice(soaStats.totalBalanceMf) : "N/A"}</p>
                        </div>
                        <div className="value">
                            <span>Currently paid - DP</span>
                            <p className="text-success">{soaStats && (soaStats.totalPaidDp || soaStats.totalPaidDp === 0) ? formatPrice(soaStats.totalPaidDp) : "N/A"}</p>
                        </div>
                        <div className="value">
                            <span>Currently paid - MF</span>
                            <p className="text-success">{soaStats && (soaStats.totalPaidMf || soaStats.totalPaidMf === 0) ? formatPrice(soaStats.totalPaidMf) : "N/A"}</p>
                        </div>
                        <div className="value">
                            <span>Total BP</span>
                            <p className="text-success">{soaStats && (soaStats.totalBp || soaStats.totalBp === 0) ? formatPrice(soaStats.totalBp) : "N/A"}</p>
                        </div>
                      </div>
                  </div>
                  <ButtonGroup
                      className="btn-group-toggle float-left mb-3 d-inline"
                      data-toggle="buttons"
                  >
                      <Button
                        color="info"
                        id="0"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: tabSelected === "principal",
                        })}
                        onClick={(e) =>
                          this.changeTabSelected(e, "tabSelected", "principal")
                        }
                      >
                        <input defaultChecked name="options" type="radio" />
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Principal
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="0"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: tabSelected === "miscelaneous",
                        })}
                        onClick={(e) =>
                          this.changeTabSelected(
                            e,
                            "tabSelected",
                            "miscelaneous"
                          )
                        }
                      >
                        <input defaultChecked name="options" type="radio" />
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Miscelaneous
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="0"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: tabSelected === "rental",
                        })}
                        onClick={(e) =>
                          this.changeTabSelected(e, "tabSelected", "rental")
                        }
                      >
                        <input defaultChecked name="options" type="radio" />
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Rental
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="0"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: tabSelected === "penalty",
                        })}
                        onClick={(e) =>
                          this.changeTabSelected(
                            e,
                            "tabSelected",
                            "penalty"
                          )
                        }
                      >
                        <input defaultChecked name="options" type="radio" />
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Penalty
                          
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="0"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: tabSelected === "commission",
                        })}
                        onClick={(e) =>
                          this.changeTabSelected(e, "tabSelected", "commission")
                        }
                      >
                        <input defaultChecked name="options" type="radio" />
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Commission
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                  </ButtonGroup>
                </div>
                <Table>
                    <thead className="text-primary">
                        <tr>
                            <th>Type</th>
                            <th>Due Date</th>
                            <th>Check number</th>
                            <th>Date paid</th>
                            <th>Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                      { loading ? 
                        <tr>
                          <td colSpan='6'>Loading ...</td>
                        </tr>
                      :
                        <>
                          {clientPayments && clientPayments.length > 0
                            ? clientPayments.map((payment) => {
                                return (
                                    <tr key={payment._id}>
                                        <td>{payment.type ? formatPaymentType(payment.type) : "N/A"} {payment.subtype ? `(${formatPaymentSubtype(payment.subtype)})` : null}</td>
                                        <td>
                                            {moment(payment.due_date).format(
                                                "MM/DD/YYYY",
                                            ) || "N/A"}
                                        </td>
                                        <td>
                                            {payment.payment_method === "Cash"
                                                ? "Cash"
                                                : payment.check_number ||
                                                  "N/A"}
                                        </td>
                                        <td>
                                            {payment.settled_date
                                                ? moment(
                                                      payment.settled_date,
                                                  ).format("MM/DD/YYYY")
                                                : "N/A"}
                                        </td>
                                        <td>
                                            {payment.amount ? (
                                                <span className={payment.status === 'completed' ? "text-success" : 'text-danger'}>
                                                    {formatPrice(
                                                        payment.amount,
                                                    )}
                                                </span>
                                            ) : (
                                                <span>0.00</span>
                                            )}
                                        </td>

                                        <td>
                                          <span className={payment.status === 'canceled' ? "text-danger" : 'text-success'}>
                                            {payment.status}
                                          </span>
                                        </td>
                                    </tr>
                                )
                              })
                            : <tr>
                                <td colSpan='6'>No payment to show</td>
                              </tr>
                            }
                        </>
                      }
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default SOA
